<template>
  <div class="relative">
    <IconButton
      :aria-label="ariaLabel"
      classes="rounded-[50%] border-2 me-16"
      :class="{
        'border-border-disabled bg-surface-disabled': disabled,
        'border-border-primary shadow-button': !disabled,
      }"
      :icon-name="iconName"
      :disabled="disabled"
      @click="handleClick"
      @keydown.enter.self.prevent="handleClick"
      @keydown.space.self.prevent="handleClick"
    />
    <AppPopoverMessage :show="showPopover && !!disabledMessage" type="warning">
      {{ disabledMessage }}
    </AppPopoverMessage>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  iconName: string;
  ariaLabel?: string;
  disabled?: boolean;
  disabledMessage?: string;
  showPopover?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  ariaLabel: undefined,
  disabledMessage: undefined,
  showPopover: false,
});

const emit = defineEmits<{
  click: [];
  'show-disabled-message': [];
}>();

const handleClick = () => {
  if (props.disabled && props.disabledMessage) {
    emit('show-disabled-message');
  } else if (!props.disabled) {
    emit('click');
  }
};
</script>
